import styled, { css } from 'styled-components'
import { StyledWrapperProps } from './interfaces'

export const Code = styled.input.attrs({ type: 'tel' })`
  width: 75.5px;
  height: 48px;
  border: ${({ theme }) => theme.border.width.thinner}
    ${({ theme }) => theme.border.style.solid}
    ${({ theme }) => theme.neutral.border.strong};
  border-radius: ${({ theme }) => theme.border.radius.medium};
  text-align: center;
  outline: none;

  &:not(:last-child) {
    margin-right: ${({ theme }) => theme.spacing.km4};
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: 100%;
  }
`

export const Wrapper = styled.div<StyledWrapperProps>`
  display: flex;

  & > input {
    ${({ $hasSomethingTyped }) =>
      !$hasSomethingTyped &&
      css`
        border: ${({ theme }) => theme.border.width.thinner}
          ${({ theme }) => theme.border.style.solid}
          ${({ theme }) => theme.neutral.border.default};
      `}

    ${({ $error }) =>
      $error &&
      css`
        border-color: ${({ theme }) => theme.danger.border.default};
        color: ${({ theme }) => theme.danger.text.default};
      `}
  }
`
